import { Link } from "react-router-dom";
import type { GalleryItem } from "@/mocks/galleries";

export default function GalleryCard({ gallery }: { gallery: GalleryItem }) {
  return (
    <Link
      to={`/image-detail/${gallery.id}`}
      className="group relative block overflow-hidden rounded-lg border border-background-200 bg-background-100 break-inside-avoid"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={gallery.cover}
          alt={`${gallery.title} - ${gallery.theme}图集封面`}
          title={`${gallery.title} ${gallery.theme} 成人图片`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.05]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/25 to-transparent opacity-90"></div>
        <span className="absolute right-2.5 top-2.5 flex items-center gap-1 rounded bg-background-950/70 px-1.5 py-0.5 text-[10px] text-foreground-700">
          <i className="ri-image-2-line"></i>
          {gallery.photoCount} 张
        </span>
        <div className="absolute inset-x-0 bottom-0 p-3.5">
          <span className="mb-1.5 inline-block rounded-sm bg-accent-500/90 px-1.5 py-0.5 text-[10px] text-background-50">
            {gallery.theme}
          </span>
          <h3 className="text-sm font-medium text-foreground-950">{gallery.title}</h3>
          <p className="mt-0.5 flex items-center gap-1 text-[11px] text-foreground-500">
            <i className="ri-camera-line"></i>
            {gallery.photographer}
          </p>
        </div>
      </div>
    </Link>
  );
}